<template>
  <page :loading='loading'>
    <template #content>
      <SubTopBar>
      <v-btn text :to="{ name: 'AddEmail' }" v-if="emailsRoute">
        <v-icon class="mr-1">mdi-email-plus</v-icon>
        <span>Add Email</span>
      </v-btn>
      <v-btn text :to="{ name: 'AddPhoneNumber' }" v-if="phoneNumbersRoute">
        <v-icon class="mr-1">mdi-phone-plus</v-icon>
        <span>Add phone number</span>
      </v-btn>
    </SubTopBar>
    <v-breadcrumbs
      :items="bcItems"
      divider=">"
      large
      />
    <v-row class="ml-5">
      <v-col cols="12">
        <div class="key">Username</div>
        <span class="value">{{username}}</span>
        <v-btn class="ml-2" icon x-small :to="{ name: 'UsernameChange' }">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12">
        <div class="key">Password  <v-btn class="ml-3" icon x-small :to="{ name: 'PasswordChange' }">
          <v-icon>mdi-pencil</v-icon>
          </v-btn></div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <template>
      <v-tabs>
        <v-tab :to="{ name: 'Emails' }">
          <v-icon left>mdi-email</v-icon>
          <span>Emails</span>
        </v-tab>
        <v-tab :to="{ name: 'PhoneNumbers' }">
          <v-icon left>mdi-phone</v-icon>
          <span>Phone numbers</span>
        </v-tab>
        <v-tab :to="{ name: 'DataAndPrivacy' }">
          <v-icon left>mdi-cog</v-icon>
          <span>Data & Privacy</span>
        </v-tab>
      </v-tabs>
      <router-view/>
    </template>
    </template>
  </page>
</template>

<script>

export default {
  name: "profile",
  data() {
    return {
      loading: false
    }
  },
  computed: {
    emailsRoute: function () {return this.$route.name == 'Emails'},
    phoneNumbersRoute: function () {return this.$route.name == 'PhoneNumbers'},
    bcItems: function () {
      return [
        {},
        {
          text: "Profile",
          disabled: false,
          exact: true,
          to: {name: 'Profile'}
        },
        {
          text: `${this.$route.meta.bcText}`,
          disabled: false,
          exact: true,
          href: `${this.$route.path}`
        },
      ]}
  },
  created: function () {
    this.$api.getNotifications(this.username, this.callBack(
      response => {
        const items = []
        const orgItems = []
        response.invitations.forEach(invitation => {
          items.push({ 
            invite: invitation
          })
        })
        response.organizationinvitations.forEach(invitation => {
          orgItems.push({ 
            invite: invitation
          })
        })
        this.$store.state.notificationCounter = items.length + orgItems.length
        this.$store.commit('setNotificationBadge')
      }
    ))
  },
}
</script>

<style scoped>

</style>